import { render, staticRenderFns } from "./ReverseLogisticsMenu.vue?vue&type=template&id=2d2ba47b"
import script from "./ReverseLogisticsMenu.vue?vue&type=script&lang=js"
export * from "./ReverseLogisticsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports